import { render, staticRenderFns } from "./currencymod.vue?vue&type=template&id=589b1c23&"
import script from "./currencymod.vue?vue&type=script&lang=js&"
export * from "./currencymod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('589b1c23')) {
      api.createRecord('589b1c23', component.options)
    } else {
      api.reload('589b1c23', component.options)
    }
    module.hot.accept("./currencymod.vue?vue&type=template&id=589b1c23&", function () {
      api.rerender('589b1c23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QDeX9E4o6ykp/JS/comp/currencymod.vue"
export default component.exports